import React from 'react'
import { Link } from 'react-router-dom'

import {
  canContinue,
  getCurrentStep,
  getPreviousStep,
  getNextStep
} from 'lib/helpers/registration/navigation'

// material ui
import Box from '@mui/material/Box'

// components
import Typography from '@mui/material/Typography'
import ResponsiveButton from 'components/atoms/ResponsiveButton'
// import ResponsiveButton from 'components/atoms/ResponsiveButton'

const NavButtons = props => {
  const {
    account,
    pathname, // via withPathname
    onClickContinue,
    disableContinue,
    mutationLoading
  } = props

  const {
    preferences: { onlineOnly = true }
  } = account

  const step = getCurrentStep({ pathname, onlineOnly })
  const previousStep = getPreviousStep({ step, onlineOnly })
  const nextStep = getNextStep({ step, onlineOnly })
  const stepCompleted = canContinue({ step, account: account })

  return (
    <Box align='center'>
      {step && nextStep && !stepCompleted && step.continueHelpText && (
        <Typography variant='body1' align='center' my={2}>
          {step.continueHelpText}
        </Typography>
      )}

      {previousStep && (
        <ResponsiveButton
          variant='contained'
          color='primary'
          component={Link}
          to={previousStep.path}
        >
          Back to {previousStep.label}
        </ResponsiveButton>
      )}

      {nextStep &&
        (onClickContinue ? (
          <ResponsiveButton
            variant='contained'
            color='secondary'
            onClick={onClickContinue}
            disabled={mutationLoading || disableContinue}
          >
            {mutationLoading
              ? 'Saving…'
              : `Save and Continue to ${nextStep.label}`}
          </ResponsiveButton>
        ) : (
          <ResponsiveButton
            variant='contained'
            color='secondary'
            component={Link}
            to={nextStep.path}
            disabled={!stepCompleted}
          >
            Continue to {nextStep.label}
          </ResponsiveButton>
        ))}
    </Box>
  )
}

export default NavButtons
